// extracted by mini-css-extract-plugin
export default {"container":"SelectInputGroup_container__0IdCX","inputGroup":"SelectInputGroup_inputGroup__ze9aQ","label":"SelectInputGroup_label__fIp3b","error":"SelectInputGroup_error__9QRj+"};